import React, { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import Header from "../Header/Header";
import consts from "../../constant";
import axios from "axios";
import "./Landing.css";
import Grid2 from "@mui/material/Grid2";
import Box from '@mui/material/Box';
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

function Landing() {
      const theme = useTheme();
    const lg = useMediaQuery(theme.breakpoints.up("lg"));
    const drawerWidth = 260;
    const [darkModeImage, setDarkModeImage] = useState(null);
    const [lightModeImage, setLightModeImage] = useState(null);
    const [darkPreview, setDarkPreview] = useState(null);
    const [lightPreview, setLightPreview] = useState(null);
    const [loading, setLoading] = useState(false);
    const [latestImages, setLatestImages] = useState({ dark: null, light: null });
    const token = localStorage?.getItem("adminToken");

    useEffect(() => {
        fetchExistingImages();
    }, []);

    const fetchExistingImages = async () => {
        try {
            const response = await axios.get(`${consts?.BackendUrl}/admin/getlanding`, {
                headers: {
                    Authorization: token,
                },
            });
            if (response.data && response?.data?.result) {
                setDarkModeImage(response?.data?.result?.dark);
                setLightModeImage(response?.data?.result?.light);
            }
        } catch (error) {
            console.error("Error fetching images:", error);
        }
    };

    const handleImageChange = async (e, mode) => {
        const file = e.target.files[0];
        if (!file) return;

        const img = new Image();
        img.src = URL.createObjectURL(file);

        img.onload = async () => {
            if (img.width !== 1483 || img.height !== 989) {
                toast.error("Image must be 1483 x 989 pixels.");
                return;
            }

            if (mode === "dark") {
                setDarkPreview(img.src);
            } else {
                setLightPreview(img.src);
            }

            const formData = new FormData();
            formData.append("image", file);

            try {
                const response = await axios.post(`${consts?.BackendUrl}/imageUpload`, formData, {
                    headers: {
                        Authorization: token,
                    },
                });

                if (response?.data?.success) {
                    const imageUrl = response?.data?.result;
                    setLatestImages((prev) => ({ ...prev, [mode]: imageUrl }));

                    if (mode === "dark") {
                        setDarkModeImage(imageUrl);
                    } else {
                        setLightModeImage(imageUrl);
                    }

                    toast.success(`${mode === "dark" ? "Dark" : "Light"} mode image uploaded!`);
                } else {
                    toast.error(response?.data?.message || "Upload failed.");
                }
            } catch (error) {
                console.error("Error uploading image:", error);
                toast.error("Failed to upload image.");
            }
        };
    };

    const submitImages = async () => {
        const darkImg = latestImages.dark || darkModeImage;
        const lightImg = latestImages.light || lightModeImage;

        if (!darkImg || !lightImg) {
            toast.dismiss();
            return toast.error("Please upload both images first!");
        }

        setLoading(true);
        try {
            const updateResponse = await axios.post(
                `${consts?.BackendUrl}/admin/landing`,
                {
                    darkMode: darkImg,
                    lightMode: lightImg,
                },
                {
                    headers: {
                        Authorization: token,
                    },
                }
            );

            if (updateResponse?.data?.success) {
                toast.success("Images saved successfully!");
            } else {
                toast.error(updateResponse?.data?.message || "Failed to save images.");
            }
        } catch (error) {
            console.error("Error updating images:", error);
            toast.error("Failed to save images.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
         <Box sx={{ display: lg ? "flex" : "block" }}>
            <Header />
            <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 2,
            width: { lg: `calc(100% - ${drawerWidth}px)` },
            marginTop: "50px",
          }}
        >
            <div className="admin-banner-image" style={{ marginTop: "50px" }}>
                <Grid2 container spacing={2}>
                    <Grid2 item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                        {/* Dark Mode Image Upload */}
                        <div  className="upload-card">
                            <h5 style={{ color: "white", fontSize: "22px", fontWeight: "bold" }}>Dark Mode Image</h5>
                            {darkPreview ? (
                                <img
                                    src={darkPreview}
                                    alt="Dark Preview"
                                    style={{ width: "296px", height: "197px", objectFit: "cover", borderRadius: "8px" }}
                                />
                                
                            ) : darkModeImage ? (
                                <img
                                    src={darkModeImage}
                                    alt="Dark Mode"
                                    style={{ width: "296px", height: "197px", objectFit: "cover", borderRadius: "8px" }}
                                />
                            ) : (
                                <p style={{ color: "gray" }}>No image uploaded</p>
                            )}<br />
                            <div className="img-size">
                            <span className="file-size" style={{ color:'red' }}>Note: Image must be 1483 x 989 pixels.</span>
                            {/* <input type="file" onChange={(e) => handleImageChange(e, "dark")} accept="image/*" /> */}
                            <label htmlFor="upload-dark" className="upload-img cursor">
                                Upload Image
                                <input
                                    id="upload-dark"
                                    type="file"
                                    className="hidden"
                                    onChange={(e) => handleImageChange(e, "dark")}
                                    accept="image/*"
                                />
                            </label>
                            </div>

                            
                        </div>
                    </Grid2>
                    <Grid2 item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                    {/* Light Mode Image Upload */}
                    <div className="upload-card">
                        <h5 style={{ color: "white", fontSize: "22px", fontWeight: "bold" }}>Light Mode Image</h5>
                        {lightPreview ? (
                            <img
                                src={lightPreview}
                                alt="Light Preview"
                                style={{ width: "296px", height: "197px", objectFit: "cover", borderRadius: "8px" }}
                            />
                        ) : lightModeImage ? (
                            <img
                                src={lightModeImage}
                                alt="Light Mode"
                                style={{ width: "296px", height: "197px", objectFit: "cover", borderRadius: "8px" }}
                            />
                        ) : (
                            <p style={{ color: "gray" }}>No image uploaded</p>
                        )}<br />
                        <div className="img-size">
                        <span className="file-size" style={{ color:'red' }}>Note: Image must be 1483 x 989 pixels.</span>
                        
                        {/* <input type="file" onChange={(e) => handleImageChange(e, "light")} accept="image/*" /> */}
                        <label htmlFor="upload-light" className="upload-img cursor">
                            Upload Image
                            <input
                                id="upload-light"
                                type="file"
                                className="hidden"
                                onChange={(e) => handleImageChange(e, "light")}
                                accept="image/*"
                            />
                        </label>
                        </div>
                    </div>
                    </Grid2>
                </Grid2>



            </div>

            {/* Save Button */}
            <div style={{ textAlign: "center", marginTop: "50px" }}>
                <button
                    onClick={submitImages}
                    disabled={loading}
                    style={{
                        padding: "12px 24px",
                        background: "#007bff",
                        color: "#fff",
                        fontSize: "16px",
                        border: "none",
                        borderRadius: "6px",
                        cursor: "pointer",
                        fontWeight: "bold",
                    }}
                >
                    {loading ? "Saving..." : "Save Images"}
                </button>
            </div>
            <Toaster />
            </Box>
            </Box>
        </>
    );
}

export default Landing;
